export function getProductsList(products) {
    if (typeof products === 'object') {
        products = [...[], products];
    }

    if (products.length === 1) {
        return products[0].bitrixID;
    } else {
        let productsIds = [];
        products.forEach(item => {
            if (!item.hasOwnProperty('bitrixID') || item.bitrixID === null) {
                productsIds.push(item.productId);
                return
            }
            productsIds.push(item.bitrixID);
        });

        return productsIds || '';
    }
}

export function getProductsTotal(products) {
    if (typeof products === 'object') {
        products = [...[], products];
    }

    let total = 0;
    let quantity = 1;

    products.forEach(item => {
        if (item.hasOwnProperty('quantity')) {
            quantity = item.quantity;
        }
        total += (parseInt(item.price) * quantity);
    });
    return total;
}


export function getCategory(products) {
    if (typeof products === 'object') {
        products = [...[], products];
    }

    let categoryName = 'category';
    products.forEach(item => {
        if (item.hasOwnProperty('searchresults')) {
            categoryName = 'searchresults';
            return
        }
    });
    return categoryName;
}